/**
 * PhotoSwipe lightbox for `.pswp-gallery` groups.
 */
(function () {
	'use strict';

	// PhotoSwipe lays image placeholders out at this width, then scale()s them.
	var PSWP_PLACEHOLDER_WIDTH = 250;

	function getOpenRadiusPct(pswp) {
		var raw = window.getComputedStyle(pswp.element).getPropertyValue('--pswp-open-radius').trim();
		var amount = parseFloat(raw);

		if (isNaN(amount)) {
			return 0.05;
		}

		if (raw.indexOf('%') !== -1) {
			return amount / 100;
		}

		return null;
	}

	function setCircularRadius(el, layoutW, layoutH, pct) {
		if (!el || !layoutW || !layoutH) {
			return;
		}

		el.style.borderRadius = Math.min(layoutW, layoutH) * pct + 'px';
	}

	function applyCircularRadius(lightbox) {
		var pswp = lightbox.pswp;
		var slide = pswp && pswp.currSlide;
		var content = slide && slide.content;
		var pct;
		var destW;
		var destH;
		var placeholder;

		if (!pswp || !pswp.element || !content) {
			return;
		}

		pct = getOpenRadiusPct(pswp);
		if (pct === null) {
			return;
		}

		destW = content.displayedImageWidth;
		destH = content.displayedImageHeight;
		placeholder = content.placeholder && content.placeholder.element;

		if (placeholder && destW && destH) {
			setCircularRadius(
				placeholder,
				PSWP_PLACEHOLDER_WIDTH,
				PSWP_PLACEHOLDER_WIDTH * (destH / destW),
				pct
			);
		}

		if (content.element) {
			setCircularRadius(
				content.element,
				content.element.offsetWidth || destW,
				content.element.offsetHeight || destH,
				pct
			);
		}
	}

	function initPhotoSwipe() {
		if (typeof PhotoSwipeLightbox === 'undefined' || typeof PhotoSwipe === 'undefined') {
			return;
		}

		document.querySelectorAll('.pswp-gallery').forEach(function (galleryEl) {
			if (galleryEl.dataset.pswpReady === '1') {
				return;
			}

			if (!galleryEl.querySelector('a.pswp-gallery__item')) {
				return;
			}

			galleryEl.dataset.pswpReady = '1';

			var lightbox = new PhotoSwipeLightbox({
				gallery: galleryEl,
				children: 'a.pswp-gallery__item',
				pswpModule: PhotoSwipe,
				showHideAnimationType: 'zoom',
				bgOpacity: 1,
				padding: { top: 100, bottom: 100, left: 16, right: 16 },
				imageClickAction: 'close',
				tapAction: 'close',
				doubleTapAction: false,
			});

			lightbox.on('initialLayout', function () {
				applyCircularRadius(lightbox);
			});
			lightbox.on('contentResize', function () {
				applyCircularRadius(lightbox);
			});
			lightbox.on('change', function () {
				applyCircularRadius(lightbox);
			});
			lightbox.on('openingAnimationStart', function () {
				applyCircularRadius(lightbox);
			});

			lightbox.init();
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initPhotoSwipe);
	} else {
		initPhotoSwipe();
	}
})();
